import { render, staticRenderFns } from "./MenuStandarEvolution.vue?vue&type=template&id=812fb404&"
import script from "./MenuStandarEvolution.vue?vue&type=script&lang=js&"
export * from "./MenuStandarEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports